import { gql } from '@apollo/client'
import { MUTATION_STATE } from '../../fragments'

const PAYLOAD = 'ArchiveVoohCampaignCreationPayload'

export const ARCHIVE_VOOH_CREATION = gql`
  ${MUTATION_STATE(PAYLOAD)}
  mutation archiveVoohCampaignCreation($voohCreationId: ID!, $archiveReason: String!) {
    archiveVoohCampaignCreation(input: { voohCreationId: $voohCreationId, archiveReason: $archiveReason }) {
      voohCreation {
        id
        details
        mediaFormat
        frameFormat
        deletedAt
        archivedAt
        archiveReason
        hourFrequency
        duration
        creationType
        file {
          filename
          url
        }
        schedules {
          startDate
          endDate
        }
        thumbnailUrl
        media {
          id
        }
      }
      ...MutationState${PAYLOAD}Fields
    }
  }
`
